






































































































































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import conEdit from '../waitRoom//conEdit.vue'
import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
import Util from '../../../lib/util'
import {GetRecipeData,ConfirmRecipe} from '../../../api/dialysisProcess'



@Component({
    components:{conEdit}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    recipeInfo:any = {}
    dialysisSign:any = {}
    patVas:any = {}
    created(){
        this.getRecipeData()

        console.log(this.refuseRecipeType)
    }
    //获取处方信息
    async getRecipeData(){
        let data = {
            RecipeId:this.data.recipeId
        }
        let res = await GetRecipeData(data)
        this.patVas = res.objects.patVas
        this.recipeInfo = res.objects.recipe
        this.dialysisSign = res.objects.dialysisSign
        this.conList.list = res.objects.recipe.recipeConsumables
        //获取到耗材列表 再加载耗材组件
        this.conEditShow = true
        //通路
        this.getvaType()
    }
    //耗材编辑弹窗
    conEditShow = false
    conList:any = {
        list:[]
    }
    
    consBack(data:any){
        this.conList.list = data
    }
    //确认处方
    async save(){
        let data = {
            type:this.refuseRecipeType,
            recipeId:this.data.recipeId,
            refuseRecipe:this.refuseRecipe,
            recipeConsumables:this.conList.list
        }
        let res = await ConfirmRecipe(data)
        if(res.status == 1){
            this.$emit('on-back')
        }
        this.$emit('input',false);
    }

   
    //表单值
    rules = {};
    
    textareaShow1 = false
    textareaShow2 = false
    textareaShow3 = false
    textareaShow4 = false
    textareaShow5 = false
    textareaShow6 = false
    textareaShow7 = false

    //拒绝原因
    refuseRecipe:any = {
        dwRf:'',
        wRf:'',
        vaRf:'',
        atRf:'',
        dtRf:'',
        dsRf:'',
        remarks:'',
    }
    //获取是否失败type
    get refuseRecipeType(){
        let flag = 0;
        for(let item in this.refuseRecipe){
            if(this.refuseRecipe[item]!=''){
                flag = 1
            }
        }
        return flag
    }

    //确认处方
    vaType = ''
    getvaType(){
        this.vaType = this.patVas.find((item:any)=>{return item.id == this.recipeInfo.patVaId}).vaType
    }
    mounted() {
        
    }
    antiWaysColumn = [
        {
            key:'antiWaysName',
            title:'抗凝方式',
        },{
            key:'medName',
            title:'抗凝药品',
        },{
            key:'antiFirstDose',
            title:'首剂',
        },{
            key:'antiFirstUnit',
            title:'首剂单位',
        },{
            key:'antiAddDose',
            title:'追加/小时',
        },{
            key:'dose',
            title:'枸橼酸剂量(ml/h)',
        },{
            key:'gaMedName',
            title:'钙剂药品',
        },{
            key:'gaDose',
            title:'钙剂剂量',
        },{
            key:'normalSalineMedName',
            title:'生理盐水药品',
        },{
            key:'normalSalineDose',
            title:'生理盐水剂量',
        },{
            key:'pumpDose',
            title:'泵 入',
        }
    ]
    
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/verifyPrescription.vue